export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_vkxlqc7",
  TEMPLATE_ID: "template_1ldb2qn",
  PUBLIC_KEY: "Ej4NDNd6eOCDe-NqP",
  TO_EMAIL: 'info@honzamedia.de'
};